import { Component, Inject } from '@angular/core';
import { ConsumerType, CONSUMER_TYPE } from '@tdwb/core';
import { environment } from '../environments/environment';
@Component({
  selector: 'td-wb-webbroker',
  templateUrl: 'webbroker.component.html',
  styleUrls: ['webbroker.component.scss'],
  standalone: false
})
export class WebbrokerComponent {
  animationsDisabled: boolean; // animations are disabled when running e2e tests in dev mode
  isEmbedded: boolean = false;

  constructor(@Inject(CONSUMER_TYPE) consumerType: ConsumerType) {
    this.animationsDisabled = environment.animationsDisabled !== undefined ? environment.animationsDisabled : false;
    this.isEmbedded = consumerType.isEmbedded;
  }
}
